import { render, staticRenderFns } from "./WorkBaseLevelTableLookALike.vue?vue&type=template&id=5697394e&scoped=true"
import script from "./WorkBaseLevelTableLookALike.vue?vue&type=script&lang=js"
export * from "./WorkBaseLevelTableLookALike.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseLevelTableLookALike.vue?vue&type=style&index=0&id=5697394e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697394e",
  null
  
)

export default component.exports